import {Field} from 'redux-form'
import styles from './COGSModalFieldArray.css'

const numberOnly = () =>
  (value, previousValue, allValues) => {
    if (value) {
      if (isNaN(value) || value.includes('.')) {
        return previousValue
      }
    }
    return value
  }

class COGSModalFieldArray extends React.Component {
  render () {
    const {fields} = this.props
    return <tbody>
      {fields.map((member, index, fields) => {
        const fieldValues = fields.get(index)
        if (fieldValues.track_stock) {
          return <tr>
            <td>{fieldValues.name}</td>
            <td className='text-center'>
              <div className='checkbox checkbox-primary checkbox-item checkbox-circle'>
                <Field
                  component='input'
                  name={`${member}.track_cogs`}
                  type='checkbox'
                  id={`checkbox-track-cogs-${index}`}
                />
                <label for={`checkbox-track-cogs-${index}`} />
              </div>
            </td>
            <td>
              <div className='form-group'>
                <div className={styles['rp-cogs']}>Rp</div>
                <Field
                  component='input'
                  name={`${member}.cogs`}
                  type='text'
                  className={`form-control text-right ${styles['input-cogs']}`}
                  disabled={fieldValues.saved_cogs}
                  normalize={numberOnly()}
                />
              </div>
            </td>
          </tr>
        }
      })}
    </tbody>
  }
}

export default COGSModalFieldArray



// WEBPACK FOOTER //
// ./app/pages/Library/Item/ItemDetail/ItemForm/COGSModal/COGSModalFieldArray/COGSModalFieldArray.js